var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{class:_vm.classes,attrs:{"small":_vm.small,"title":_vm.title}},[_vm._v(_vm._s(_vm.iconName))])}
var staticRenderFns = []

export { render, staticRenderFns }